import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaUser, FaBars, FaTimes } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  

  const styles = {
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '14px 30px',
      backgroundColor: '#fff',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      fontFamily: "'Segoe UI', sans-serif",
      position: 'sticky',
      top: 0,
      zIndex: 1000,
    },
    logoSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
    },
    logo: {
      height: '45px',
    },
    logoText: {
      fontSize: '22px',
      fontWeight: '700',
      color: '#FF5A1F',
    },
    hamburger: {
      fontSize: '26px',
      cursor: 'pointer',
    },
    sideMenu: {
      position: 'fixed',
      top: 0,
      left: menuOpen ? 0 : '-250px',
      height: '100%',
      width: '250px',
      backgroundColor: '#fff',
      boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
      padding: '30px 20px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      transition: 'left 0.3s ease',
      zIndex: 1100,
    },
    closeIcon: {
      fontSize: '24px',
      alignSelf: 'flex-end',
      cursor: 'pointer',
    },
    navLink: {
      textDecoration: 'none',
      color: '#333',
      fontWeight: '500',
      fontSize: '16px',
      transition: 'color 0.3s ease',
    },
    loginBtn: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      padding: '8px 14px',
      backgroundColor: '#FF5A1F',
      color: '#fff',
      borderRadius: '5px',
      fontWeight: '600',
      textDecoration: 'none',
      marginTop: '20px',
    },
  };

  return (
    <>
      <header style={styles.header}>
      
<div style={styles.logoSection}>
  <Link to="/" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
    <img src="/Property_Plateau_logo.jpg" alt="Property Plateau Logo" style={styles.logo} />

  </Link>
</div>


        {/* Hamburger Icon */}
        <div style={styles.hamburger}>
          <FaBars onClick={toggleMenu} />
        </div>
      </header>

      {/* Side Menu */}
      <div style={styles.sideMenu}>
        <FaTimes style={styles.closeIcon} onClick={closeMenu} />
        <Link to="/buy" style={styles.navLink} onClick={closeMenu}>Buy</Link>
        <a href="https://holidayhomes.propertyplateau.com/" style={styles.navLink} onClick={closeMenu} target="_blank" rel="noopener noreferrer">
        Rent
          </a>

        {/* <Link to="/rent" style={styles.navLink} onClick={closeMenu}>Rent</Link>//navigate to https://holidayhomes.propertyplateau.com/ this link */}
        <Link to="/service" style={styles.navLink} onClick={closeMenu}>Our Services</Link>
        <Link to="/brand" style={styles.navLink} onClick={closeMenu}>Our Brand</Link>
        <Link to="/about-us"style={styles.navLink} onClick={closeMenu}>About Us</Link>
        <a href="https://www.propertyplateautimes.com/" style={styles.navLink} onClick={closeMenu}>

  News
        </a>


        <Link to="/career" style={styles.navLink} onClick={closeMenu}>Career</Link>
        <Link to="/contactus" style={styles.navLink} onClick={closeMenu}>Contact Us</Link>

        <
          Link to="/sign-in" 
          state={{ from: location.pathname }} 
          style={styles.loginBtn} 
          onClick={closeMenu}
        >
          <FaUser />
          <span>Login</span>
        </Link>
        
      </div>
    </>
  );
}

export default Header;
